import { FC } from "react";

import TabbedSection from "components/common/TabbedSection/TabbedSection";
import useActivityActions, { ActivityActionOptions } from "../../hooks/useActivityActions";

type ActivityProps = ActivityActionOptions & {
  // define rest of the component props here...
};

const Activity: FC<ActivityProps> = function ({ shipmentId, shipmentDetails, isOffPlatform }) {
  const { intl, actKey, tabs, handleTabSelect, isLoadingTrackingUpdates } = useActivityActions({
    shipmentId,
    shipmentDetails,
    isOffPlatform,
  });

  return (
    <TabbedSection
      activeKey={actKey}
      isLoading={isLoadingTrackingUpdates}
      onTabSelect={handleTabSelect}
      tabs={tabs}
      title={intl.formatMessage({
        id: "general.activity",
        defaultMessage: "Activity",
      })}
    />
  );
};

export default Activity;
